import { render, staticRenderFns } from "./accountMgt.vue?vue&type=template&id=28da6b2c&scoped=true&"
import script from "./accountMgt.vue?vue&type=script&lang=js&"
export * from "./accountMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da6b2c",
  null
  
)

export default component.exports